import { cloneDeep } from 'lodash';

import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import ExpandMenu from '../../../../assets/data/expanded-menu.json';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';

import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { DownloadService } from '@shared/services/download/download.service';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { ExpandedMenuService } from '@shared/services/expanded-menu/expanded-menu.service';
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';
import { ConvertDatePipe } from '../../../shared/filters/convert-date/convert-date.pipe';
import { ByWordChildrenPipe } from '@shared/filters/by-word-children/by-word-children.pipe';
import { ByWordPipe } from '../../../shared/filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { PaginationControlComponent } from '../../../shared/components/pagination-control/pagination-control.component';
import { EvaluationBlanqueoRowComponent } from '../evaluation-blanqueo-row/evaluation-blanqueo-row.component';
import { FilterByOrderComponent } from '../../../shared/components/filter-by-order/filter-by-order.component';
import { FilterBySearchAndOrderComponent } from '../../../shared/components/filter-by-search-and-order/filter-by-search-and-order.component';
import { FilterByListAndOrderComponent } from '../../../shared/components/filter-by-list-and-order/filter-by-list-and-order.component';
import { ParticipantsListComponent } from '../../../shared/components/participants-list/participants-list.component';
import { SharedModule } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { NgClass, NgStyle } from '@angular/common';
import { SpanTooltipComponent } from '../../../shared/components/span-tooltip/span-tooltip.component';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonWithMenuActionComponent } from "../../../shared/components/button-with-menu-action/button-with-menu-action.component";
import { ButtonWithTextMenuArrowComponent } from "../../../shared/components/button-with-text-menu-arrow/button-with-text-menu-arrow.component";
import { AfOrderByWithDescPipe } from '@shared/filters/af-order-by-with-desc/af-order-by-with-desc.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { PdfTableComponent } from '@shared/components/pdf-table/pdf-table.component';

@Component({
    selector: 'evaluations-list',
    templateUrl: './evaluations-list.component.html',
    standalone: true,
    imports: [
      TooltipModule,
      SpanTooltipComponent,
      NgClass,
      FormsModule,
      SharedModule,
      ParticipantsListComponent,
      NgStyle,
      FilterByListAndOrderComponent,
      FilterBySearchAndOrderComponent,
      FilterByOrderComponent,
      EvaluationBlanqueoRowComponent,
      PaginationControlComponent,
      AfOrderByWithDescPipe,
      AfOrderByPipe,
      AfTranslatePipe,
      ByWordPipe,
      ByWordChildrenPipe,
      ConvertDatePipe,
      AfLimitToPipe,
      ButtonWithMenuActionComponent,
      ButtonWithTextMenuArrowComponent,
      AfTranslateDirective,
      PdfTableComponent
    ]
})
export class EvaluationsListComponent implements OnChanges {
  skin:string = this.globalCfg.skin;
  dashboardVersion:any = parseInt(this.globalCfg.dashboardVersion);
  expandedMenu: any = ExpandMenu;
  evaluationsList:any ={
    expandedMenu: this.expandedMenu['evaluationsListAction'].menu,
    expandedMenuDemo: this.expandedMenu['evaluationsListMenu'].menu,
    openEvaluationViewDropdown: false,
    configPagination: {
      itemsPerPage: 50,
      pageLinkSize: 5,
      currentPage: 1,
      firstElement: 0,
    },
    amountElements: 0,
    productId: '',
    search: false,
    searchEvaluation: '',
    order: false,
    filterOrder: 'name',
    title: this.translate.instant('common.implantations'),
    view: 'all',
    evaluationViewItem: {
      keyName: 'name',
      maxWidth: '200px'
    },
    filters: ['clientName', 'result'],
    filterTypes: ['name', 'clientName'],
    nameFilter: { name: this.translate.instant('common.identifier'), filterOrder: 'name' },
    clientNameFilter: { name: this.translate.instant('common.organization'), filterOrder: 'clientName' },
    resultFilter: { name: this.translate.instant('evaluations-list.finish-result') },
    complaintsFilter: { name: this.translate.instant('dashboard-reports.complaints'), filterOrder: 'complaints' },
    publishDateFilter: { name: this.translate.instant('common.publication'), filterOrder: 'publishDate' },
    modifiedFilter: { name: this.translate.instant('common.modification'), filterOrder: 'modified' },
    evaluations: [],
    evaluationView: [],
    sharedEvaluations: [],
    evaluationsListFilter: [],
    closeAdviseHasDemo: false
  }
  constructor(private router: Router,
    private translate: AfTranslateFactory,
    private globalCfg: GlobalCfgFactory,
    private loader: LoaderFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private filterColumnService: FilterColumnService,
    private context: ContextFactory,
    private downloadService: DownloadService,
    private exportService: ExportServiceService,
    private dateConverterService: DateConverterService,
    private registerService: RegisterMixtapeService,
    private expandedMenuService: ExpandedMenuService,
    private registerEventService: RegisterMixtapeService) { }

  @Input() isConcursalFormsModal: boolean = false;
  @Input() canCreate: boolean = false;
  @Input() canModify: boolean = false;
  @Input() productSelected: any;
  @Input() filteredEvaluations: any = [];
  @Input() deletedEvaluations: any = [];
  @Output() launchAction = new EventEmitter();
  @Output() copyEvaluation = new EventEmitter();

  ngOnChanges() {
    if(this.productSelected?.productId){
      this.evaluationsList.clientNameFilter.label = this.productSelected.productId === 'blanqueo'?this.translate.instant('common.client'):this.translate.instant('common.organization');
      this.evaluationsList.evaluations = this.filteredEvaluations;
      this.evaluationsList.productId = this.productSelected.productId;
      if(this.context.settings.defaultProduct === 'blanqueo'){
        this.evaluationsList.title = this.translate.instant('evaluations-list.opportunity-evaluations');
        for(let i = 0; i < this.evaluationsList.evaluations?.length; i++){
          let evaluation : any = this.evaluationsList.evaluations[i];
          evaluation.stateName = '';
          if(evaluation.operationLocked || evaluation.operationNotSupported){
            evaluation.stateName = evaluation.operationLocked?this.translate.instant('common.locked'):this.translate.instant('evaluation-header.not-supported');
          }
        }
        this.configureViewBlanqueo();
      }else {
        this.configEvaluationView();
        if(this.dashboardVersion === 2 || this.evaluationsList.productId ==='denunc'){
          this.evaluationsList.title = this.translate.instant('common.channels');
        }else{
          this.evaluationsList.title = this.translate.instant('common.implantations');
        }
      }
      let productsDemo: any = localStorage.getItem('productsDemo')
      if(productsDemo){
        this.evaluationsList.productsDemo = JSON.parse(productsDemo);
        this.evaluationsList.closeAdviseHasDemo = Boolean(this.evaluationsList.productsDemo[`${this.productSelected.productId}CloseAdviseHasDemo`])
      }
      this.evaluationsList.evaluationWithDemo = this.findDemo() && this.productSelected.productId ==='penal'
      if(this.evaluationsList.evaluations && this.evaluationsList.evaluations.length && this.deletedEvaluations && !this.isConcursalFormsModal) {
        this.getSharedEvaluations();
      }else{
        this.changeView(this.evaluationsList.view);
      }
    }
  }

  configEvaluationView(){
    this.evaluationsList.evaluationView = [
      {
        name: this.translate.instant('common.active'),
        viewOption: 'all'
      },
      {
        name: this.translate.instant('common.removed'),
        viewOption: 'deleted'
      }
    ];
    if (!this.isConcursalFormsModal && this.dashboardVersion === 1){
      let shared : any = {
        name: this.translate.instant('common.shared'),
        viewOption: 'shared'
      };
      this.evaluationsList.evaluationView.splice(1,0,shared);
    }
    this.evaluationsList.view ='all';
    this.evaluationsList.selectedView = this.evaluationsList.evaluationView[0];
  }

  configureViewBlanqueo(){
    this.evaluationsList.evaluationView = [
      {
        name: this.translate.instant('evaluations-list.recent-activity'),
        viewOption: 'last15'
      },
      {
        name: this.translate.instant('common.active'),
        viewOption: 'active'
      },
      {
        name: this.translate.instant('evaluations-list.grouping-by-client'),
        viewOption: 'groupClients'
      },
      {
        name: this.translate.instant('evaluations-list.all-evaluations'),
        viewOption: 'all'
      },
      {
        name: this.translate.instant('common.removed'),
        viewOption: 'deleted'
      }
    ];
    this.evaluationsList.view ='last15';
    this.evaluationsList.selectedView = this.evaluationsList.evaluationView[0];
  }

  findDemo(){
    return Boolean(this.filteredEvaluations.findIndex((evaluation:any)=>{ return evaluation.isDemo}) !== -1)
  }

  getSharedEvaluations(){
    this.apiService.get('company', 'dashboard/evaluations/sharings')
    .then((data: any)=> {
      let newData : any = [];
      Object.entries(data).forEach(([key, value]) => {
        let info : any = {
          key: parseInt(key),
          shared: value
        }
        newData.push(info);
      })
      newData.forEach((item:any) => {
        for(let j = 0; j < this.evaluationsList.evaluations.length; j++){
          if(item.key === this.evaluationsList.evaluations[j].evaluationId){
              this.evaluationsList.evaluations[j].shared = item.shared;
              this.evaluationsList.sharedEvaluations.push(this.evaluationsList.evaluations[j]);
              break;
          }
        }
      });

      this.changeView(this.evaluationsList.view);
    }, (errorData:any)=>{
    });
  }

  changeViewEmit(type: any){
    this.changeView(type);
    this.evaluationsList.resetPagination = true;
  }

  changeView(type: any){
    this.evaluationsList.view = type;
    this.evaluationsList.evaluationsFilter = [];
    this.evaluationsList.filterTypes = this.productSelected?.productId === 'blanqueo'?['name', 'clientName', 'result']:['name', 'clientName'];
    let list : any =[];
    switch(this.evaluationsList.view){
      case 'shared':
          this.evaluationsList.evaluationsFilter = this.evaluationsList.sharedEvaluations;
          break;
      case 'deleted':
          this.evaluationsList.evaluationsFilter = this.deletedEvaluations;
          break;
      case 'last15':
          list = this.evaluationsList.evaluations?this.evaluationsList.evaluations.sort(this.orderListDate):[];
          this.evaluationsList.evaluationsFilter = list.slice(0, 15);
          break;
      case 'active':
        list = this.evaluationsList.evaluations?this.takeActivesEvaluation(this.evaluationsList.evaluations):[];
        this.evaluationsList.evaluationsFilter = list;
        break;
      case 'groupClients':
          this.evaluationsList.filterTypes = ['name', 'result'];
          list = this.evaluationsList.evaluations?this.takeClientsList(this.evaluationsList.evaluations):[];
          this.evaluationsList.clientsList = list;
          this.evaluationsList.clientsListFilter = this.evaluationsList.clientsList;
          this.evaluationsList.evaluationsFilter = this.evaluationsList.evaluations;
          break;
      default:
          this.evaluationsList.evaluationsFilter = this.evaluationsList.evaluations;
          break;
    }
    this.evaluationsList.evaluationsListFilter = this.evaluationsList.evaluationsFilter;
    this.evaluationsList.evaluationView.forEach((view:any) => {
      if(view.viewOption === type){
        this.evaluationsList.selectedView = view;
      }
    });
    this.resetAndConfigureFilters(type);
    this.getAmountElements();
    if(!this.evaluationsList.closeHasDemo){
      this.hasDemo()
    }
  }

  resetAndConfigureFilters(type: any){
    this.evaluationsList['nameSearchFilter'] = '';
    delete this.evaluationsList['nameFilter'].value;
    this.evaluationsList.filters.forEach((option: any) => {
      this.evaluationsList[option+'ListFilter'] = [];
      delete this.evaluationsList[option+'Filter'].hasFilter;
    });
    if(this.evaluationsList.evaluationsFilter?.length){
      if(this.evaluationsList.productId ==='blanqueo' && type !== 'groupClients'){
        this.evaluationsList.order = true;
        this.evaluationsList.filterOrder = 'modified';
      }else{
        this.evaluationsList.order = false;
        this.evaluationsList.filterOrder = 'name';
      }
      this.getFilters();
    }
    this.configureOrderElement('name');
  }

  orderListDate(a: any, b: any) {
    if(a.modified < b.modified){
      return 1
    }
    return a.modified > b.modified ? -1 : 0;
  }

  takeActivesEvaluation(list: any){
    let finishedEvaluation : any = [];
    list.forEach((evaluation:any) => {
      if(!evaluation.finished){
        finishedEvaluation.push(evaluation);
      }
    });
    return finishedEvaluation;
  }

  takeClientsList(list: any){
    let clientsList : any = [];
    let order : any = 0;
    list.forEach((evaluation:any) => {
      let existClient : any = this.checkExistClient(clientsList, evaluation.clientId);
      if(!existClient){
        order++;
        let client : any = {
          type: 'client',
          order: order,
          evaluationId: this.commonUtilsService.createId(),
          clientId: evaluation.clientId,
          clientName: evaluation.clientName,
          evaluations: this.takeEvaluationsClient(list, evaluation.clientId)
        }
        clientsList.push(client);
      }
    });

    return clientsList;
  }

  checkExistClient(list: any, clientId: any){
    for(let evaluation of list){
      if(evaluation.clientId === clientId){
        return true;
      }
    }
    return false;
  }

  takeEvaluationsClient(list: any, clientId: any){
    let evaluationsClient : any = [];
    list.forEach((evaluation:any) => {
      if(evaluation.clientId === clientId){
        evaluationsClient.push(evaluation);
      }
    });
    return evaluationsClient;
  }

  getFilters(){
    this.evaluationsList.filters.forEach((filter:any) => {
      this.evaluationsList[filter+'List'] = this.filterColumnService.extractList(filter, this.evaluationsList.evaluationsFilter)
      this.evaluationsList[filter+'ListFilter'] = [];
    });
  }

  filterOrder(e: any, type:any=''){
    switch(e.action){
      case 'filter':
        this.selectTypeOperation(e.newValue, type);
        break;
      case 'search':
        this.evaluationsList[type+'SearchFilter'] = e.newValue;
        this.filterEvaluation(type);
        break;
      case 'order':
        this.orderBy(e.newValue);
        break;
    }
  }

  selectTypeOperation(item: any, type: any){
    let listFilter = this.evaluationsList[type+'ListFilter'];
    this.evaluationsList[type+'ListFilter'] = this.filterColumnService.configureFilterList(listFilter, item);
    this.filterEvaluation();
  }

  orderBy(type:any){
    if(this.evaluationsList.filterOrder === type){
      this.evaluationsList.order = !this.evaluationsList.order;
    }else{
      this.evaluationsList.filterOrder = type;
      this.evaluationsList.order = true;
    }
    this.configureOrderElement(type);
  }

  configureOrderElement(type: string='name'){
    this.evaluationsList.orderElement = {
      type: type,
      direction: 'asc'
    }
  }

  filterEvaluation(type: any = undefined){
    let filterList = this.commonUtilsService.findByWord(this.evaluationsList.evaluationsFilter, this.evaluationsList.searchEvaluation, this.evaluationsList.filterTypes);
    if(type){
      filterList = this.filterColumnService.filterByWord(this.evaluationsList[type+'SearchFilter'], filterList, type);
    }
    if(this.evaluationsList.evaluationsFilter?.length){
      this.evaluationsList.filters.forEach((filter:any) => {
        let filteredList = this.evaluationsList[filter+'ListFilter'];
        filterList = this.filterColumnService.filterBycolumn(filterList, filteredList, filter);
      });
    }
    this.evaluationsList.evaluationsListFilter = filterList;
    if(this.evaluationsList.view === 'groupClients' && (type === 'result' || type === 'name' || type === 'clientName')){
      this.configureGroupClientList();
    }
    this.evaluationsList.amountElements = this.evaluationsList.evaluationsListFilter.length;
  }

  configureGroupClientList(){
    let clients : any = [];
    this.evaluationsList.clientsList.forEach((client:any) => {
      for(let evaluation of client.evaluations){
        let evaluationShow : any = this.searchEvaluationClient(evaluation);
        if(evaluationShow){
            clients.push(client);
            break;
        }
      }
    });
    this.evaluationsList.clientsListFilter = clients;
  }

  searchEvaluationClient(evaluation: any) {
    for (let evaluationFilter of this.evaluationsList.evaluationsListFilter) {
      if (evaluationFilter.evaluationId === evaluation.evaluationId) {
        return true;
      }
    }
    return false;
  }

  createNewEvaluation(){
    let registerItem: any = {
      event: 'create implantation'
    }
    this.registerEventService.register(registerItem);
    this.launchAction.emit({ action: 'newEvaluation'});
  }

  editOption(evaluation: any){
    if(evaluation.isDemo){
      let registerItem: any = {
        event: 'Demo implementation'
      }
      this.registerService.register(registerItem);
    }
    if(this.evaluationsList.view !== 'deleted'){
      let resgisterItem:any ={
        event:'open implantation',
        source: 'implantation'
      }
      this.registerService.register(resgisterItem)
      evaluation.popoverIsOpen = false;
      this.loader.openLoader('dashboard-panel-create-evaluation');
      if(this.canCreate || this.canModify){
        this.isUpgradeable(evaluation);
      }else{
        this.router.navigate(['evaluation',evaluation.evaluationId]);
      }

      if (evaluation.productId === 'forms') {
        this.launchAction.emit({ action: 'edit'});
      }
    }
  }

  isUpgradeable(evaluation: any){
    this.apiService.get('evaluations/needupdateversion', evaluation.evaluationId)
      .then((data: any)=> {
        if(data === 1){
          this.loader.closeLoader(['dashboard-panel-create-evaluation']);
          this.updateEvaluation(evaluation);
        }else{
          this.router.navigate(['evaluation',evaluation.evaluationId]);
        }
      }, (errorData:any)=>{
        this.router.navigate(['evaluation',evaluation.evaluationId]);
      });
  }

  updateEvaluation(evaluation: any){
    let itemSelected : any = {
      type: 'update-evaluation',
      item: evaluation
    }

    this.modalService.informativeLoadingModal(itemSelected).subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.loader.openLoader('dashboard-panel-create-evaluation');
        this.router.navigate(['evaluation',evaluation.evaluationId]);
      }else{
        this.modalService.errorModal({ text: this.translate.instant('evaluations-list.error-update') })
          .subscribe((result:any) => {
            if(result.result === 'ok'){
              this.loader.openLoader('dashboard-panel-create-evaluation');
              this.router.navigate(['evaluation',evaluation.evaluationId]);
            }
          });
      }
    });
  }

  shareEvaluation(evaluation: any) {
    let registerItem: any = {
      event: 'share implantation'
    }
    this.registerService.register(registerItem);
    this.modalService.evaluationShare(evaluation).subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.evaluationsList.sharedEvaluations = [];
        this.getSharedEvaluations();

        // let secondaryText : any = ' ';
        // if(result.documents && result.documents !== null && result.documents.length){
        //     secondaryText = this.translate.instant('evaluation-share.attached-ok');
        // }
        this.openInfoModal(this.translate.instant('evaluation-share.shared-ok'));
      }
    });
  }

  duplicateEvaluation(evaluation: any){
    let type: string = evaluation.isDemo?'Duplicate demo deployment':'duplicate implantation';
    let registerItem: any = {
      event: type
    }
    this.registerService.register(registerItem);

    // Desactivando esta opción se vería la modal de duplicar con formato especial
    // evaluation.specialModal = evaluation.productId === 'blanqueo';
    this.modalService.duplicateEvaluationModal(evaluation).subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.copyEvaluation.emit({
          newEvaluation:{
            evaluation: evaluation,
            copyInfo: result.evaluationInfo
          }
        });
      }
    });
  }

  rename(evaluation: any){
    let configuration : any = {
      title: this.translate.instant('dashboard.rename-evaluation'),
      type: 'evaluation',
      previousTitle: evaluation.name,
      evaluationId: evaluation.evaluationId,
      list: [],
      rename: true
    }
    this.modalService.renameModal(configuration).subscribe((result:any) => {
      if(result.result === 'ok'){
        this.loader.openLoader('concept-tab-rename-modal');
        evaluation.name = result.name;
        configuration.previousTitle = result.name;
        this.saveRename(configuration);
      }
    })
  }

  saveRename(newItem: any){
    let url : any = "evaluations/rename/"+newItem.evaluationId;
    this.apiService.patch(url, 0, { Name: newItem.previousTitle }).then((data) => {
      this.loader.closeLoader(['concept-tab-rename-modal']);
      let text : string = this.translate.instant('dashboard.rename-evaluation-ok');
      this.openInfoModal(text);
    }).catch((errorData:any) => {
      this.loader.closeError();
      let text : string = this.translate.instant('concept-tab.error-name');
      if(errorData.description==='UqConstraint'){
          text = this.translate.instant('concept-tab.error-same-name');
      }
      this.errorModal(text);
    });
  }

  restoreEvaluation(evaluation: any){
    let repeatedSelectedClient = false;
    if (this.isConcursalFormsModal) {
      for (let index in this.evaluationsList.evaluations) {
        let formsEvaluation = this.evaluationsList.evaluations[index];
        if (formsEvaluation.clientId === evaluation.clientId) {
            repeatedSelectedClient = true;
            break;
        }
      }
    }

    if (repeatedSelectedClient) {
      this.errorModal(this.translate.instant('evaluations-list.restore-repeated-client-error'));
    } else {
        const modalConfig = {
          text: this.translate.instant('dashboard.restore-implantation-question'),
          typeButtons: 'restore'
        }
        this.modalService.infoModal(modalConfig).subscribe((result:any) => {
          if(result.result === 'ok'){
            this.loader.openLoader('restore-evaluation');
            this.launchAction.emit(
              {
                action: 'restoreEvaluation',
                evaluation: evaluation
              });
          }
        });
    }
  }

  deleteEvaluation(evaluation: any){
    let actionDelete = 'deleteEvaluation';
    if(this.evaluationsList.view  === 'deleted'){
      let registerItem: any = {
        event: 'delete implantation'
      }
      this.registerService.register(registerItem);
      actionDelete = 'deleteEvaluationDefinitely';
    }
    this.launchAction.emit({
      action: actionDelete,
      evaluation: evaluation
    });
  }

  exportList(){
    this.modalService.exportFormatModal({})
      .subscribe((result:any) => {
        if(result.result === 'ok'){
          let config: any = {
            idPrint: 'evaluation-list-report-pdf',
            list: cloneDeep(this.evaluationsList.evaluations),
            typeColumns: this.productSelected?.productId === 'blanqueo'?['clientName', 'name', 'result', 'stateName', 'modifiedIso']:['name', 'clientName', 'complaints', 'publishDateIso'],
            nameDocument: `${this.translate.instant('evaluations-list.list-of')} ${this.evaluationsList.title+(result.selectedFormat==='xls'?'.xlsx':'.pdf')}`,
            title: this.evaluationsList.title,
            columns: this.configureColumns(),
            uploadFile: false,
            landscape: true,
            successCallback: (response:any, blob:any) => {
              delete this.evaluationsList.configurationPdf;
              this.downloadService.triggerDownload(blob, config.nameDocument);
              this.modalService.successModal({ text: this.translate.instant('common.export-excel-ok')});
            }
          };
          config.list.forEach((evaluation:any) => {
            if(this.productSelected?.productId === 'blanqueo'){
              evaluation.modifiedIso = this.dateConverterService.convertDate(evaluation.modified, 'without-time');
            }else{
              if(evaluation.publishDate){
                evaluation.publishDateIso = this.dateConverterService.convertDate(evaluation.publishDate, 'without-time');
              }else{
                evaluation.publishDateIso = this.translate.instant('evaluations-list.unpublished');
              }
            }
          })
          switch (result.selectedFormat) {
            case 'xls':
              this.exportService.toXls(config);
              break;
            case 'pdf':
              config.exportDate = this.dateConverterService.setTimezone(new Date());
              config.orderType = this.evaluationsList.filterOrder;
              config.orderAsc = this.evaluationsList.order;
              // config.orderType = 'modified';
              // config.orderAsc = true;
              this.evaluationsList.configurationPdf = config;
              let that : any = this;
              setTimeout(()=>{
                let htmlPrint : any = $('#'+config.idPrint).html();
                config.htmlPrint = htmlPrint;
                that.exportService.toPdf(config);
              })
              break;
          }
        }
      });
  }

  configureColumns(){
    if(this.productSelected?.productId === 'blanqueo'){
      return {
        clientName: this.translate.instant('common.client'),
        name: this.translate.instant('common.identifier'),
        result: this.translate.instant('evaluations-list.finish-result'),
        stateName: this.translate.instant('common.state'),
        modifiedIso: this.translate.instant('evaluations-list.modification-date'),
      }
    }else{
      return {
        name: this.evaluationsList.nameFilter.name,
        clientName: this.evaluationsList.clientNameFilter.name,
        complaints: this.evaluationsList.complaintsFilter.name,
        publishDateIso: this.evaluationsList.publishDateFilter.name,
      }
    }
  }

  // toggleSearch(){
  //     this.evaluationsList.search = !this.evaluationsList.search;
  //     if (!this.evaluationsList.search) {
  //         this.evaluationsList.searchEvaluation = '';
  //     }
  //     this.filterEvaluation();
  // }

  openInfoModal(text:string){
    this.modalService.successModal({ text: text });
  }

  errorModal(text:string){
    this.modalService.errorModal({ text: text });
  }

  clickRow(evaluation: any){
    this.evaluationsList.view === 'deleted'?this.restoreEvaluation(evaluation):this.editOption(evaluation);
  }

  emitEventFromRow(e:any){
    switch(e.type){
      case 'editOption':
        this.editOption(e.evaluation);
        break;
      case 'rename':
        this.rename(e.evaluation);
        break;
      case 'restoreEvaluation':
        this.restoreEvaluation(e.evaluation);
        break;
      case 'deleteEvaluation':
        this.deleteEvaluation(e.evaluation);
        break;
    }
  }

  showTooltip(id:any){
      return this.commonUtilsService.showTooltip(id)
  }

  changeDropdown(openDropdown: any){
    this.evaluationsList[openDropdown] = !this.evaluationsList[openDropdown];
  }

  searchList(){
    this.getAmountElements();
    this.evaluationsList.filteredSearchEmpty = this.evaluationsList.amountElements?false:true;
  }

  getAmountElements(){
    this.evaluationsList.amountElements = this.findByWord().length;
  }

  hasDemo(){
    this.evaluationsList.hasDemo = Boolean(this.evaluationsList.evaluationsListFilter.findIndex((evaluation:any)=>{ return evaluation.isDemo}) !== -1)
  }

  findByWord(){
    return this.commonUtilsService.findByWord(this.evaluationsList.evaluationsListFilter, this.evaluationsList.searchEvaluation, this.evaluationsList.filterTypes);
  }

  cleanFilter(){
    this.evaluationsList.searchEvaluation = '';
    this.filterEvaluation();
    this.getAmountElements();
  }

  openActionEvaluation(evaluation: any){
      let optionAction = {
        view: this.evaluationsList.view,
        productId: evaluation.productId,
        isConcursalFormsModal: this.isConcursalFormsModal,
        canCreate: this.canCreate
      };
      let menuSelected :any = evaluation.isDemo? this.evaluationsList.expandedMenuDemo : this.evaluationsList.expandedMenu
      evaluation.expandedMenu = this.expandedMenuService.evaluationsListAction(menuSelected, evaluation, optionAction);
      evaluation.openMenuAction = true;
  }

  selectOption(action: any, evaluation: any){
    switch(action){
      case 'open':
        this.editOption(evaluation);
        break;
      case 'share':
        this.shareEvaluation(evaluation);
        break;
      case 'duplicate':
        this.duplicateEvaluation(evaluation);
        break;
      case 'rename':
        this.rename(evaluation);
        break;
      case 'delete':
        this.deleteEvaluation(evaluation);
        break;
    }
  }

  emptyMessage(){
    if(this.evaluationsList.filteredSearchEmpty){
      return this.translate.instant('new-evaluation.no-results');
    }else{
      return this.evaluationsList.view === 'deleted'?this.translate.instant('evaluations-list.no-deleted-evaluations'):this.translate.instant('common.no-generated').replace('{key}', this.evaluationsList.title.toLowerCase());
    }
  }

  changeCurrentPage(e: any){
    this.evaluationsList.configPagination.currentPage = e.currentPage;
    this.evaluationsList.configPagination.firstElement = e.firstElement;
  }

  closeAdviseHasDemo(){
    this.evaluationsList.closeAdviseHasDemo = true;
    this.evaluationsList.productsDemo[`${this.productSelected.productId}CloseAdviseHasDemo`] = true
    localStorage.setItem('productsDemo', JSON.stringify(this.evaluationsList.productsDemo))
  }
}
